import { pageInfoFragment } from "@saleor/fragments/pageInfo";
import makeBossQuery from "@saleor/hooks/makeBossQuery";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import {
  InitialMerchantSettlementFilterDataQuery,
  InitialMerchantSettlementFilterDataQueryVariables
} from "./types/InitialMerchantSettlementFilterDataQuery";
import {
  MerchantSettlement,
  MerchantSettlementVariables
} from "./types/MerchantSettlement";
import {
  MerchantSettlementReport,
  MerchantSettlementReportVariables
} from "./types/MerchantSettlementReport";

export const MerchantSettlementQuery = gql`
  ${pageInfoFragment}
  query MerchantSettlement(
    $before: String
    $after: String
    $first: Int
    $last: Int
    $filter: MerchantSettlementFilterInput!
  ) {
    merchantSettlement(
      before: $before
      after: $after
      first: $first
      last: $last
      filter: $filter
    ) {
      totalCount
      pageInfo {
        ...PageInfoFragment
      }
      edges {
        cursor
        node {
          id
          batch_id
          brand_name
          company_name
          mall_name
          settlement_date
          coverage_start_date
          coverage_end_date
          net_settlement
        }
      }
    }
  }
`;

export const useMerchantSettlementQuery = makeBossQuery<
  MerchantSettlement,
  MerchantSettlementVariables
>(MerchantSettlementQuery);

export const initialMerchantSettlementFilterDataQuery = gql`
  query InitialMerchantSettlementFilterDataQuery($brand: [ID], $mall: [ID]) {
    brands(first: 5, filter: { id: $brand }) {
      edges {
        node {
          id
          name
        }
      }
    }
    malls(first: 5, filter: { id: $mall }) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const useInitialMerchantSettlementFilterDataQuery = makeQuery<
  InitialMerchantSettlementFilterDataQuery,
  InitialMerchantSettlementFilterDataQueryVariables
>(initialMerchantSettlementFilterDataQuery);

export const MerchantSettlementReportQuery = gql`
  query MerchantSettlementReport($payoutId: ID) {
    merchantSettlementReport(payoutId: $payoutId) {
      edges {
        node {
          id
          mall_name
          brand_name
          store_order_code
          delivery_type
          payment_method
          total_gross_amount
          tenant_discount
          net_sales
          tenant_voucher
          payment_fee
          total_deductions
          adjustment_on_payment_fee
          adjustment_on_delivery_fee
          penalties
          other_adjustments
          other_adjustment_remarks
          total_adjustments
          creditable_withholding_tax_on_prepaid
          withholding_tax_on_payment_fee
          in_store_cash_payments
          net_amount_for_settlement
        }
      }
      summary {
        payout_id
        mall_name
        brand_name
        legal_name
        settlement_date
        coverage_start_date
        coverage_end_date
        total_gross_amount
        tenant_voucher
        total_payment_fee
        total_deductions
        adjustment_on_payment_fee
        adjustment_on_delivery_fee
        penalties
        other_adjustments
        total_adjustments
        creditable_withholding_tax_on_prepaid
        withholding_tax_on_payment_fee
        in_store_cash_payments
        net_amount_for_settlement
        total_tax
        gross_amount_settlement
        net_sales
        tenant_discount
      }
    }
  }
`;

export const useMerchantSettlementReportQuery = makeBossQuery<
  MerchantSettlementReport,
  MerchantSettlementReportVariables
>(MerchantSettlementReportQuery);
